import { EFontWeights } from '@appcharge/shared-ui';
import { OfferUI } from 'common/contracts';
import { DEFAULT_BORDER_COLOR, DEFAULT_BORDER_WIDTH, PROGRESS_BAR_DEFAULTS, PROMOTION_DEFAULTS } from 'views/OfferDesign/OfferDesign.consts';
import { OfferDesignTypes } from 'views/OfferDesign/OfferDesign.types';
import { normalizeBgColor } from 'views/OfferDesign/OfferDesign.utils';

export const buildBundlePayload = (
  formValues: Record<string, any>,
  offerType: OfferDesignTypes
): OfferUI => {
  const payload: OfferUI = {
    active: true,
    offerUiType: offerType,
    name: formValues.name,
    externalId:
      formValues.externalId?.trim().replace(/\s+/g, '_') ||
      formValues.name.trim().replace(/\s+/g, '_'),
    description: 'description',
    backgroundImage: formValues.backgroundImage,
    horizontalBackgroundImage: '',
    buttonSuffixImage: formValues.buttonSuffixImage || '',
    buttonSuffixAnimation: formValues.buttonSuffixAnimation || '',
    borderColor: formValues.borderColor || DEFAULT_BORDER_COLOR,
    borderWidth: formValues.borderWidth != null ? Number(formValues.borderWidth) : DEFAULT_BORDER_WIDTH
  } as OfferUI;

  const bgColor = normalizeBgColor(formValues.backgroundColor);
  if (bgColor) {
    if (offerType === OfferDesignTypes.Bundle) {
      payload.backgroundColor = bgColor as any;
    } else {
      payload.specialOffer = { backgroundColor: bgColor } as any;
    }
  }

  return payload;
};

export const buildPromotionPayload = (
  formValues: Record<string, any>,
  offerType: OfferDesignTypes
): OfferUI => {
  const payload: OfferUI = {
    active: true,
    offerUiType: offerType,
    name: formValues.name,
    externalId:
      formValues.externalId?.trim().replace(/\s+/g, '_') ||
      formValues.name.trim().replace(/\s+/g, '_'),
    description: 'description',
    backgroundImage: formValues.backgroundImage,
    horizontalBackgroundImage: '',
    buttonSuffixImage: formValues.buttonSuffixImage || '',
    buttonSuffixAnimation: formValues.buttonSuffixAnimation || '',
    borderColor: formValues.borderColor || DEFAULT_BORDER_COLOR,
    borderWidth: formValues.borderWidth != null ? Number(formValues.borderWidth) : DEFAULT_BORDER_WIDTH
  } as OfferUI;

  payload.specialOffer = {
    templateType: PROMOTION_DEFAULTS.templateType,
    presentOfferEndTimer: false,
    title: formValues.title || '',
    fontSize: Number(formValues.fontSize) || PROMOTION_DEFAULTS.fontSize,
    fontWeight: (formValues.fontWeight || PROMOTION_DEFAULTS.fontWeight) as EFontWeights,
    fontColor: formValues.fontColor || PROMOTION_DEFAULTS.fontColor,
    subTitle: {
      text: formValues.subTitleText || '',
      fontSize: Number(formValues.subTitleFontSize) || PROMOTION_DEFAULTS.subFontSize,
      fontWeight: formValues.subTitleFontWeight || PROMOTION_DEFAULTS.fontWeight,
      fontColor: formValues.subTitleFontColor || PROMOTION_DEFAULTS.fontColor
    },
    backgroundColor: normalizeBgColor(formValues.backgroundColor),
    collectText: formValues.collectText || PROMOTION_DEFAULTS.collectText
  } as any;

  return payload;
};

export const buildProgressBarPayload = (
  formValues: Record<string, any>,
  offerType: OfferDesignTypes
): OfferUI => {
  const barBgColor = normalizeBgColor(formValues.barBackgroundColor) || PROGRESS_BAR_DEFAULTS.backgroundColor;

  const payload: OfferUI = {
    active: true,
    offerUiType: offerType,
    name: formValues.name,
    externalId:
      formValues.externalId?.trim().replace(/\s+/g, '_') ||
      formValues.name.trim().replace(/\s+/g, '_'),
    description: 'description',
    backgroundImage: '',
    horizontalBackgroundImage: '',
    borderColor: normalizeBgColor(formValues.borderColor) || PROGRESS_BAR_DEFAULTS.borderColor,
    borderWidth: formValues.borderWidth != null ? Number(formValues.borderWidth) : PROGRESS_BAR_DEFAULTS.borderWidth,
    backgroundColor: barBgColor
  } as OfferUI;

  payload.progressBar = {
    backgroundOpacity: Number(formValues.backgroundOpacity) ?? PROGRESS_BAR_DEFAULTS.backgroundOpacity,
    frameRadius: Number(formValues.frameRadius) ?? PROGRESS_BAR_DEFAULTS.frameRadius,
    barFillColor: normalizeBgColor(formValues.barFillColor) || PROGRESS_BAR_DEFAULTS.barFillColor,
    backgroundColor: barBgColor,
    barRadius: Number(formValues.barRadius) ?? PROGRESS_BAR_DEFAULTS.barRadius,
    accumulatedItem: {
      imageUrl: formValues.accumulatedItemImageUrl || '',
      backgroundColor: PROGRESS_BAR_DEFAULTS.accumulatedItemBackgroundColor
    },
    textColor: formValues.textColor || PROGRESS_BAR_DEFAULTS.textColor
  } as any;

  return payload;
};
